import { createContext } from 'react';

import { CookieConsentContextType } from './types';

// ----------------------------------------------------------------------

export const CookieConsentContext = createContext({} as CookieConsentContextType);
